import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { Item } from 'src/app/shared/models/Item';
import { ItemsAlbum } from 'src/app/shared/models/ItemsAlbum';
import { ItemsTrack } from 'src/app/shared/models/ItemsTrack';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-items-perstrack-dwn',
  templateUrl: './items-perstrack-dwn.component.html',
  styleUrls: ['./items-perstrack-dwn.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ItemsPerstrackDwnComponent implements OnInit {
  lbl_go_Back: string = "back_";
  lbl_search: string = "search_";
  lbl_track: string = "track_";
  lbl_new_record: string = "new_record_";
  lbl_item: string = "item_";
  lbl_collection: string = "collection_";
  lbl_id: string = "id_";
  lbl_name: string = "name_";
  lbl_status: string = "status_";
  lbl_file: string = "file_";
  lbl_edit: string = "edit_";
  lbl_entry_item:string="entry_item_";
  lbl_download: string = "download_";
  lbl_approve: string = "approve_";
  lbl_duration: string = "duration_";
  lbl_length: String = "length_"
  lbl_total: String = "total_"
  lbl_delete_record: string = "delete_record_";
  lbl_save: string = "save_";
  lbl_play: string = "play_";
  lbl_stop: string = "stop_";
  lbl_confirm: string = "confirm_";
  lbl_exit: string = "exit_";
  lbl_yes: string = "yes_";
  lbl_no: string = "no_"
  lbl_wish_to_continue: string = "wish_to_continue_"
  lbl_message: string;
  lbl_loading: string = "loading_";

  someSubscription: any;
  folderId: string = "DIGITALITEMS";
  itemId: string;
  albumId: string;
  token: string;
  itemDialog: boolean;
  itemDialogTrack: boolean;
  lstItemsTrak: ItemsTrack[];
  lstItemsTrakFull: ItemsTrack[];
  itemsAlbum: ItemsAlbum;
  selectedItemsTrak: ItemsTrack = null;
  filteredItemsTrack: ItemsTrack[] = [];
  item: Item = null;
  security: SecurityDocument;
  responseFile?: ResponseFile;
  sequence: string;
  dnwGroup: string;
  name: string;
  duration: string;
  length: string;
  status: string;
  fileName: string;
  imageSrc: string = '';
  selLang: string;
  dataParent: any;
  passKey: string;
  blocked: boolean = true;

  mapReadyItems = new Map();
  ctSongs = 0;

  playlist = [
    { name: 'music1', play: false }

  ]


  // Redirect to album 
  itemIdAlbum: string;
  dnwGroupAlbum: string;
  tokenAlbum: string;
  languageAlbum: string;
  device: string;
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService

  ) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.queryParams as any;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.someSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Here is the dashing line comes in the picture.
        // You need to tell the router that, you didn't visit or load the page previously, so mark the navigated flag to false as below.
        this.router.navigated = false;
      }
    });

  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {
          this.itemIdAlbum = params.itemIdAlbum;
          this.dnwGroupAlbum = params.dnwGroupAlbum;
          this.tokenAlbum = params.tokenAlbum;
          this.languageAlbum = params.languageAlbum;
          this.device = params.device;

          this.itemId = params.itemId;
          this.albumId = params.albumId;
          this.token = params.token;
          this.dnwGroup = params.dnwGroup;
          this.selLang = params.language;
          this.passKey = params.passKey;
        });


    if (this.passKey) {
      this.findPurchItmDwnByPassKey();
    } else {
      this.getSecurity();
    }
  }
  ngOnDestroy() {
    if (this.someSubscription) {
      this.someSubscription.unsubscribe();
    }
  }
  getSecurity() {

    this.apiService.findSecurityById({ "id": this.token }).then(
      data => {
        this.security = data;
        if (this.security) {
          this.getTranslatedLabels();
          this.listItemsTrackByItemAlbum();
          this.getItemsAlbumById();
          this.listItemsTrackByItemLanguage();
        }
      });
  }
  async listItemsTrackByItemAlbum() {
    this.lstItemsTrak = [];
    await this.apiService.listItemsTrackByItemAlbum({
      "itemId": this.security.guideId,
      "albumId": this.albumId,
      "language": this.selLang,
      "guideId": this.security.guideId
    }).then(
      data => {
        this.lstItemsTrak = data;
        this.lbl_message = "loading ... 1 / " + this.lstItemsTrak.length;
        this.getItemById();

      });
  }

  hideDialog() {
    this.itemDialog = false;
    this.selectedItemsTrak = null;
    this.listItemsTrackByItemAlbum();
  }
  eventCancel() {
    this.stopFile();
    window.close();
    this.router.navigate(['santov/itemsPersAlbums'], { queryParams: { itemId: this.itemIdAlbum, token: this.tokenAlbum, dnwGroup: this.dnwGroupAlbum, language: this.languageAlbum, device: this.device } });
  }
  delete() {
  }
  createUpdateTrack() {

    let savedItmTrack: ItemsTrack;
    if (this.fileName == null && this.selectedItemsTrak != null && this.selectedItemsTrak.fileName != null) {
      this.fileName = this.selectedItemsTrak.fileName;
    }
    if (this.selectedItemsTrak == null || this.selectedItemsTrak.id.sequence == null) {
      this.apiService.createItemsTrack({
        "id": {
          "itemId": this.security.guideId,
          "albumId": this.albumId,
          "language": this.selLang,
          "sequence": this.sequence
        },
        "name": this.name,
        "duration": this.duration,
        "length": this.length,
        "status": "N",
        "fileName": this.fileName

      }).then(
        data => {
          savedItmTrack = data;

          this.hideDialog();
        });

    } else {

      this.apiService.updateItemsTrack({
        "id": {
          "itemId": this.security.guideId,
          "albumId": this.albumId,
          "language": this.selLang,
          "sequence": this.selectedItemsTrak.id.sequence
        },
        "name": this.name,
        "duration": this.duration,
        "length": this.length,
        "status": this.selectedItemsTrak.status,
        "fileName": this.fileName
      }).then(
        data => {
          savedItmTrack = data;

          this.hideDialog();
        });
    }

  }


  removeSelected(selItm: ItemsTrack) {
    
    this.confirmationService.confirm({
      message: this.lbl_wish_to_continue,
      header: this.lbl_confirm + ' ' + this.lbl_delete_record+ ': <'+selItm.name+'>',
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // do accept action
        this.doremove(selItm);
        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });
  }
  doremove(selItm: ItemsTrack){
    this.apiService.deleteItemsTrack(
      {
        "id": {
          "itemId": this.security.guideId,
          "albumId": selItm.id.albumId,
          "language": selItm.id.language,
          "sequence": selItm.id.sequence
        },
        "name": selItm.name,
        "fileName": selItm.fileName,
        "duration": selItm.duration,
        "length": selItm.length,
        "status": selItm.status
      }
    ).then(
      data => {
        this.listItemsTrackByItemAlbum();
      }).catch(error => {
        console.error(error);
      });
  }


  disabledEditRules(itm: ItemsTrack) {
    let result: boolean = true;
    if (itm.fileName == null || itm.status != 'A') {
      result = false;
    }
    return result;
  }
  getItemsAlbumById() {
    this.apiService.getItemsAlbumById(
      {
        "itemId": this.security.guideId,
        "albumId": this.albumId,
        "language": this.selLang
      }
    ).then(
      data => {
        this.itemsAlbum = data;

      });
  }


  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_new_record, this.lbl_item, this.lbl_collection, this.lbl_id, this.lbl_name, this.lbl_status, this.lbl_file, this.lbl_edit, this.lbl_download, this.lbl_approve, this.lbl_duration, this.lbl_length, this.lbl_search, this.lbl_total, this.lbl_delete_record, this.lbl_save, this.lbl_play, this.lbl_stop, this.lbl_confirm, this.lbl_exit, this.lbl_yes, this.lbl_no, this.lbl_wish_to_continue, this.lbl_loading, this.lbl_track,this.lbl_entry_item]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_item = map.get(this.lbl_item);
        this.lbl_collection = map.get(this.lbl_collection);
        this.lbl_id = map.get(this.lbl_id);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_file = map.get(this.lbl_file);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_download = map.get(this.lbl_download);
        this.lbl_approve = map.get(this.lbl_approve);
        this.lbl_duration = map.get(this.lbl_duration);
        this.lbl_length = map.get(this.lbl_length);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_track = map.get(this.lbl_track);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_play = map.get(this.lbl_play);
        this.lbl_stop = map.get(this.lbl_stop);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_exit = map.get(this.lbl_exit);
        this.lbl_yes = map.get(this.lbl_yes);
        this.lbl_no = map.get(this.lbl_no);
        this.lbl_wish_to_continue = map.get(this.lbl_wish_to_continue);
        this.lbl_loading = map.get(this.lbl_loading);
        this.lbl_entry_item = map.get(this.lbl_entry_item);
      });
  }
  onClickPlayFile(itm: ItemsTrack) {

    if (Constants.playingTrack) {
      let newTrack = '';
      //  if (itm.idToPlay) {
      newTrack = itm.idToPlay;
      //  } else {
      //    newTrack = itm.id.itemId + "_" + itm.id.albumId + "_" + itm.id.sequence + "_" + this.selLang + "." + this.item.sellUM;
      //  }

      if (newTrack != Constants.playingTrack) {
        this.stopFile();
        Constants.playingTrack = newTrack;
        this.playFile();
      } else {
        this.stopFile();
      }

    } else {
      if (itm.idToPlay) {
        Constants.playingTrack = itm.idToPlay;
      } else {
        Constants.playingTrack = itm.id.itemId + "_" + itm.id.albumId + "_" + itm.id.sequence + "_" + this.selLang + "." + this.item.sellUM;
      }

      this.playFile();
    }
  }

  playFile() {
    this.lbl_message = "Now Playing: " + this.mapReadyItems.get(Constants.playingTrack);
    Constants.sound = new Audio("data:audio/MP3;base64," + Constants.mapPlayList.get(Constants.playingTrack));
    Constants.sound.controls = true;
    Constants.sound.play();


  }
  stopFile() {
    this.lbl_message = "";
    if (Constants.playingTrack && Constants.sound) {
      let base64 = Constants.mapPlayList.get(Constants.playingTrack);
      if (base64) {

        Constants.sound.pause();
        Constants.sound.currentTime = 0;
        Constants.playingTrack = null;
      }
    } else if (!Constants.sound) {

      Constants.sound = new Audio("data:audio/mp3;base64," + Constants.mapPlayList.get(this.itemId + this.albumId + "001" + "_" + this.selLang + "." + this.item.sellUM));
      Constants.sound.pause();
      Constants.sound.currentTime = 0;
      Constants.playingTrack = null;
      Constants.sound = null;
    }
  }

  async getBase64File(data: ItemsTrack[]) {
    this.ctSongs = 0;

    this.blocked = true;
    this.mapReadyItems = new Map();

    Constants.mapPlayList = new Map();
    if (data.length == null || data.length == 0) {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }
    try {
      data.forEach(async (element) => {
        if (element.idToPlay) {
          let nameFile = element.idToPlay;
          await this.apiService.getFileBinSantoApp(
            {
              "nameFile": nameFile,
              "folderId": this.folderId
            }
          ).then(
            resp => {

              this.ctSongs = this.ctSongs + 1;
              if (this.ctSongs == this.lstItemsTrak.length) {
                this.lbl_message = "List ready to play... DON NOT CLOSE THIS WINDOW";
                setTimeout(() => {
                  this.blocked = false;
                }, 1500);
              } else {
                this.lbl_message = this.lbl_loading + " " + (this.ctSongs + 1) + " / " + this.lstItemsTrak.length;
              }
              var reader = new FileReader();
              reader.readAsDataURL(resp);
              let self = Constants;
              reader.onloadend = function () {
                let array = (<string>reader.result).split(",");
                var base64data = array[1];
                self.mapPlayList.set(nameFile, array[1]);
              }

              for (let ct = 0; ct < this.lstItemsTrak.length; ct++) {
                if (this.lstItemsTrak[ct].id.sequence == element.id.sequence) {
                  this.lstItemsTrak[ct].readyToPlay = 'READY';
                  this.mapReadyItems.set(nameFile, element.name);
                }
              }

            }).catch(error => {
              console.error(error);
            }).finally(() => {
              setTimeout(() => {
                this.blocked = false;
              }, 1500);
            });
        }
      })
    } catch (parseError) {
      console.error("An error ocurred:", parseError);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'problema al procesar archivos', life: 5000 });
    } finally {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }

  }

  returnConfirm() {
    //Confirm
    this.confirmationService.confirm({
      message: this.lbl_wish_to_continue,
      header: this.lbl_confirm + ' ' + this.lbl_exit.toUpperCase(),
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // do accept action
        this.eventCancel();
        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      }
    });
  }
  findPurchItmDwnByPassKey() {
    this.apiService.findPurchItmDwnByPassKey(
      {
        "id": this.passKey,
        "language": this.selLang
      }
    ).then(
      data => {
        if (data) {
          this.itemId = data.purchItmDwn.id.itemId;
          this.selLang = data.purchItmDwn.id.language;
          this.security = {};
          this.security.language = this.selLang;

          this.getTranslatedLabels();
          this.listItemsTrackByItemAlbum();
          this.getItemsAlbumById();
        }

      });
  }
  listItemsTrackByItemLanguage() {
    this.lstItemsTrak = [];
    this.apiService.listItemsTrackByItemLanguage({
      "language": this.selLang
    }).then(
      data => {
        this.lstItemsTrakFull = data;


      });
  }
  filterItemsTrack(event) {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    let query = event.query.toLowerCase();

    for (let i = 0; i < this.lstItemsTrakFull.length; i++) {
      let country = this.lstItemsTrakFull[i];
      if (country.name.toLowerCase().indexOf(query) != -1) {
        filtered.push(country);
      }
    }

    this.filteredItemsTrack = filtered;
  }
  redirectDtl(event) {
    if (this.selectedItemsTrak && this.selectedItemsTrak.id) {

      this.apiService.createItemsTrack({
        "id": {
          "itemId": this.security.guideId,
          "albumId": this.albumId,
          "language": this.selLang
        },
        "name": this.selectedItemsTrak.name,
        "duration": this.selectedItemsTrak.duration,
        "length": this.selectedItemsTrak.length,
        "status": "A",
        "fileName": this.fileName,
        "idToPlay": this.selectedItemsTrak.id.itemId + "_" + this.selectedItemsTrak.id.albumId + "_" + this.selectedItemsTrak.id.sequence + "_" + this.selectedItemsTrak.id.language + ".MP3"

      }).then(
        data => {
          this.listItemsTrackByItemAlbum();
          this.selectedItemsTrak = null;

        });

      //this.router.navigate(['santov/itemTracksDwn'], { queryParams: { itemId: this.selectedItemsTrak.id.itemId, albumId: this.selectedItemsTrak.id.albumId, token: this.token, dnwGroup: this.dnwGroup, device: this.device } });
    }
  }
  getItemById() {
    this.apiService.getItemByIdLang(
      {
        "itemId": this.itemId,
        "language": this.selLang
      }
    ).then(
      data => {
        this.item = data;
        this.getBase64File(this.lstItemsTrak);
      }).catch(error => {
        console.error(error);
      });
  }
  moveUp(selItm: ItemsTrack) {
    this.apiService.moveItemsTrack(
      {
        "id": {
          "itemId": this.security.guideId,
          "albumId": selItm.id.albumId,
          "language": selItm.id.language,
          "sequence": selItm.id.sequence
        },
        "orderToPlay": "up"
      }
    ).then(
      data => {
        this.listItemsTrackByItemAlbum();
      }).catch(error => {
        console.error(error);
      });
  }
  moveDown(selItm: ItemsTrack) {
    this.apiService.moveItemsTrack(
      {
        "id": {
          "itemId": this.security.guideId,
          "albumId": selItm.id.albumId,
          "language": selItm.id.language,
          "sequence": selItm.id.sequence
        },
        "orderToPlay": "down"
      }
    ).then(
      data => {
        this.listItemsTrackByItemAlbum();
      }).catch(error => {
        console.error(error);
      });
  }

}
